"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Creates event listener which when added to parent will be triggered only if event has occured on children
 * parent.addEventListener('click', childrenListener(selector, handler)) is like
 * $(parent).on('click', selector, handler)
 */
function childrenListener(selector, handler) {
    return function (event) {
        var parent = event.currentTarget;
        var children = [].slice.call(parent.querySelectorAll(selector));
        var toCall = Array.prototype.some.call(children, function (child) {
            return child.contains(event.target);
        });
        if (toCall) {
            handler(event);
        }
    };
}
exports.childrenListener = childrenListener;
/**
 * Emits a custom 'keyup' event on the given input and changes its value
 */
function typeIn(input, key) {
    var event = getCustomEvent('keyup', { key: key, keyCode: key.charCodeAt(0) });
    input.value += key;
    input.dispatchEvent(event);
}
exports.typeIn = typeIn;
/**
 * Emits custom 'keydown' event on the given input
 */
function keyDownOn(element, key, keyCode) {
    var keyDown = getCustomEvent('keydown', { key: key, keyCode: keyCode });
    element.dispatchEvent(keyDown);
}
exports.keyDownOn = keyDownOn;
/**
 * Emits custom 'keydown', 'keypress', 'keyup' events on the given input
 */
function press(input, key, keyCode) {
    var keyDown = getCustomEvent('keydown', { key: key, keyCode: keyCode });
    var keyPress = getCustomEvent('keypress', { key: key, keyCode: keyCode });
    var keyUp = getCustomEvent('keyup', { key: key, keyCode: keyCode });
    input.dispatchEvent(keyDown);
    input.dispatchEvent(keyPress);
    input.dispatchEvent(keyUp);
}
exports.press = press;
/**
 * Emits a custom 'paste' event on the given input and updates its value
 */
function pasteIn(input, text) {
    var event = getCustomEvent('paste', { dataType: 'text/plain', data: text });
    input.value = text;
    input.dispatchEvent(event);
}
exports.pasteIn = pasteIn;
/**
 * Emits a custom 'cut' event on the given input and updates its value
 */
function cutIn(input) {
    var event = getCustomEvent('cut', { dataType: 'text/plain' });
    input.value = '';
    input.dispatchEvent(event);
}
exports.cutIn = cutIn;
/**
 * Emits a custom 'resize' event
 */
function resize(element) {
    var event = getCustomEvent('resize');
    element.ownerDocument.defaultView.dispatchEvent(event);
}
exports.resize = resize;
/**
 * Emits a custom 'focusin' event
 */
function focusIn(element) {
    var event = getCustomEvent('focusin');
    element.ownerDocument.dispatchEvent(event);
}
exports.focusIn = focusIn;
function getCustomEvent(name, extendedProps, initProps) {
    if (extendedProps === void 0) { extendedProps = {}; }
    if (initProps === void 0) { initProps = { bubbles: true, cancelable: false }; }
    var customEvent = new CustomEvent(name, initProps);
    Object.keys(extendedProps).forEach(function (prop) {
        customEvent[prop] = extendedProps[prop];
    });
    return customEvent;
}
exports.getCustomEvent = getCustomEvent;
